import React, {useState, useEffect} from 'react';

import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';


const ActionDialog = (props) => {
  const [open, setOpen] = useState(props.open)

  useEffect(() => {
    setOpen(props.open)
  },[props.open])

  const handleClick = (action) => {
    action()
    setOpen(false)
  }

  return (
    <Dialog open={open}>
      <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {props.description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {props.actions.map((action, idx) => (
          <Button key={action.title} onClick={()=>handleClick(action.action)} color="primary" variant={ action.variant ? action.variant : 'text' } datacy={action.datacy}>
            {action.title}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
}

export default ActionDialog